import { useContext } from "react";
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { decodeToken, isExpired } from "react-jwt";
import CryptoJS from "crypto-js";
import { EntraDeviceIDSecretKey } from "../../config/Config";
import { ENTRA_SCOPES } from "../../config/Config";
import { authenticationService } from "../../services/AuthenticationService";
import axios from "axios";
import { useInterval } from "react-interval-hook";
import { AppDB } from "../../App";

export default function EntraHook(justLogin = false, toast, handleLogout) {
	const isAuthenticated = useIsAuthenticated();
	const { instance, inProgress, accounts } = useMsal();
	var [azureLoginState, setAzureLoginState] = useState({
		deviceId: null,
		accessToken: "",
		isAuthenticated: false,
		groups: [],
		pageLoding: false,
		data:{},
		firstLoadSuccess: false // if the page load for the first time
	});

	var [isGettingAToken, setIsGettingAToken] = useState(true);
	var [loginLoading, setLoginLoading] = useState(true);
	var [firstLoadSuccess, setFirstLoadSuccess] = useState(true);
	var [firstLoadSuccess1, setFirstLoadSuccess1] = useState(false);

	async function loadAndAuthenticate() {
		// console.log(isAuthenticated)
		if (isAuthenticated) {
			var loggedIn = await authenticationService.login();
			if (loggedIn.status) {
				return loggedIn
			} else {
				await toast?.show({
					severity: "error",
					summary: " Access Denied",
					detail: "Your account is not authorized to access this application. Please contact support for assistance.",
					life: 4000
				});

				setTimeout(() => {
					instance.logoutRedirect().catch((error) => console.log(error));
				}, 4000);
			}
		}
		return [];
	}
	// loadAndAuthenticate();

	async function requestToken() {
		// Trigger the login process using popup
		const loginResponse = await instance.loginPopup({
			scopes: ["User.Read"]
		});
	}

	async function proccessing() {
		const accessTokenRequest = {
			scopes: ["User.Read"],
			account: accounts[0]
			//forceRefresh: true,
			//refreshTokenExpirationOffsetSeconds: 28800 // 8 hours
		};
		if (!isAuthenticated) {
			localStorage.removeItem("central-site-token");
		}

		if (isAuthenticated) {
			var tok = localStorage.getItem("central-site-token");
			//var deviceID = localStorage.getItem("central-site-deviceID");
			if (tok) {
				try {
					const isMyTokenExpired = isExpired(tok);
					if (!isMyTokenExpired) {
						//const bytes = CryptoJS.AES.decrypt(deviceID, EntraDeviceIDSecretKey);
						//const original = bytes.toString(CryptoJS.enc.Utf8);
						// console.log(azureLoginState.firstLoadSuccess)
						if (firstLoadSuccess === true) {
							setAzureLoginState({ ...azureLoginState, pageLoding: true });
							setLoginLoading(true);
							setFirstLoadSuccess(false);
							var auth = await loadAndAuthenticate();
							setLoginLoading(false);
							setAzureLoginState({
								...azureLoginState,
								accessToken: tok,
								isAuthenticated: isAuthenticated,
								groups: auth.groups,
								data: auth.data,
								pageLoding: false
							});
						}

						return;
					}
				} catch (error) {
					console.log(error);
					return false;
				}
			}
		}

		window.isLoggin = false;

		if (inProgress === InteractionStatus.None && justLogin === false && isAuthenticated === true) {
			window.isLoggin = true;
			accessTokenRequest.accessTokenRequest = accessTokenRequest;
			window.expose_instance = instance.acquireTokenSilent(accessTokenRequest);
			window.toast = toast;

			instance
				.acquireTokenSilent(accessTokenRequest)
				.then(async (accessTokenResponse) => {
					localStorage.setItem("central-site-token", accessTokenResponse.idToken);
					setAzureLoginState({ ...azureLoginState, pageLoding: true });
					setFirstLoadSuccess1(true);
					var auth = await loadAndAuthenticate();
					setFirstLoadSuccess1(false);
					setAzureLoginState({
						...azureLoginState,
						accessToken: accessTokenResponse.idToken,
						isAuthenticated: isAuthenticated,
						groups: auth.groups,
						data: auth.data,
						pageLoding: false
					});
				})
				.catch((error) => {
					if (error instanceof InteractionRequiredAuthError) {
						instance.acquireTokenRedirect(accessTokenRequest);
					}
					console.log(error);
					window.isLoggin = false;
				});
		}
	}

	useEffect(() => {
		proccessing();
	}, [instance, accounts, inProgress, isAuthenticated, isGettingAToken]);

	//try to request a new token every 30 sec
	// useInterval(
	// 	() => {
	// 		if (isAuthenticated && justLogin === false) {
	// 			//if the login service is not requesting
	// 			// the refresh the state to get a new token   or use the current one on the local storage
	// 			if (!firstLoadSuccess1) {
	// 				setIsGettingAToken(!isGettingAToken);
	// 			}
	// 		}
	// 	},
	// 	30000,
	// 	{
	// 		autoStart: true,
	// 		immediate: false,
	// 		selfCorrecting: false,
	// 		onFinish: () => {
	// 			console.log("Callback when timer is stopped");
	// 		}
	// 	}
	// );

	//check if the token expired every 3 seconds on the local_storage, if so then just clear the local storage.
	// the refresh entra service to get a new token and device id
	// useInterval(
	// 	() => {
	// 		if (isAuthenticated && justLogin === false) {
	// 			var tok = localStorage.getItem("central-site-token");

	// 			if (tok) {
	// 				const isMyTokenExpired = isExpired(tok);
	// 				if (isMyTokenExpired) {
	// 					localStorage.clear();
	// 				}
	// 			}
	// 		}
	// 	},
	// 	3000,
	// 	{
	// 		autoStart: true,
	// 		immediate: false,
	// 		selfCorrecting: false,
	// 		onFinish: () => {
	// 			console.log("Callback when timer is stopped");
	// 		}
	// 	}
	// );

	const activeAccount = instance.getActiveAccount();

	return { isAuthenticated, instance, azureLoginState, requestToken };
}
